import React from 'react';

import { Box, Header as BokehHeader, rem } from '@vimeo/bokeh';

import { HeaderContainer, SubHeader } from './styles';
import { defaultTemplateProps } from '../../utils/interface';
import { getModalHeader, getModalSubheader } from '../../utils/utils';
import DismissIcon from '../common/DismissIcon';

interface Props {
  modalConfig?: defaultTemplateProps;
  onClose: VoidFunction;
  userName?: string;
}

const Header = (props: Props) => {
  const modalSubHeader = getModalSubheader(props.modalConfig?.subHeaderText);
  const overrideHeaderText = props.modalConfig?.headerText;
  const showHeader = overrideHeaderText !== '' && overrideHeaderText !== null;

  return (
    <HeaderContainer>
      <Box w="100%" px={{ base: rem(16), md: 0 }}>
        {showHeader && (
          <BokehHeader size="lg" data-testid="upsell-header-text" textAlign="center">
            {getModalHeader(props.modalConfig?.headerText)}
          </BokehHeader>
        )}
        {modalSubHeader ? (
          <SubHeader data-testid="upsell-subheader-text">{modalSubHeader}</SubHeader>
        ) : null}
      </Box>
      <DismissIcon margin={rem(8)} onClose={props.onClose} />
    </HeaderContainer>
  );
};

export default Header;
